/* Photo swatches progressively enhance ordinary variant links. No catalogue fetch. */
(() => {
  const root = document.querySelector('[data-collection-design]');
  if (!root) return;
  const enhance=()=>root.querySelectorAll('[data-card-colour]').forEach(link => {
    link.setAttribute('role', 'button');
    link.setAttribute('aria-pressed', String(link.classList.contains('is-selected')));
  });
  enhance();document.addEventListener('diyion:results-updated',enhance);
  root.addEventListener('keydown', event => {
    const link = event.target.closest('[data-card-colour]');
    if (link && event.key === ' ') { event.preventDefault(); link.click(); }
  });
  root.addEventListener('click', event => {
    const choice = event.target.closest('[data-card-colour]');
    if (!choice || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
    const card = choice.closest('[data-collection-card]');
    const photo = card.querySelector('.dc-card-image');
    if (!photo || !choice.dataset.image) return;
    event.preventDefault();
    card.querySelectorAll('[data-card-colour]').forEach(link => {
      link.classList.toggle('is-selected', link === choice);
      link.setAttribute('aria-pressed', String(link === choice));
    });
    photo.srcset = choice.dataset.srcset;
    photo.src = choice.dataset.image;
    photo.alt = card.dataset.title + ' · ' + choice.dataset.colour;
    card.querySelectorAll('[data-card-link]').forEach(link => { link.href = choice.href; });
    const price = card.querySelector('.dc-card-price');
    price.textContent = choice.dataset.priceText;
    let comparison = card.querySelector('.dc-card-compare');
    if (choice.dataset.compareText) {
      if (!comparison) { comparison = document.createElement('s'); comparison.className = 'dc-card-compare'; price.after(comparison); }
      comparison.textContent = choice.dataset.compareText;
    } else comparison?.remove();
    card.dataset.price = choice.dataset.priceNumber;
    card.querySelector('[data-card-status]').textContent = choice.dataset.colour + ' · ' + choice.dataset.priceText;
  });
})();
